/**
 * MeterReadingsComponent created by karora on 28/03/17.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { MeterReading } from '../types/meter-reading';

@Component({
  selector: 'meter-readings',
  templateUrl: './meter-readings.component.html',
  styleUrls: ['./meter-readings.component.css'],
  providers: [HubService],
})


export class MeterReadingsComponent implements OnInit {
  readings: MeterReading[];
  hubID: number;
  private fromTimestamps: string[];
  errorMessage: string;

  static handleRefreshError(err: any): void {
    if (err.status !== 401) {
      console.log('MeterReadings Error: ' + err);
    }
  }

  constructor(
    private hubService: HubService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.route.params.pipe(
      switchMap((params: Params) => this.switchedHub(+params['hubid']))
    ).subscribe();
  }

  switchedHub(hubID: number): Observable<boolean> {
    console.log('Switched HUB: ' + hubID);
    this.hubID = hubID;
    this.fromTimestamps = <string[]>{};
    this.later();
    return of(true);
  }

  newReadings(readings: MeterReading[]): void {
    let updated = <MeterReading[]>[];
    for (let r of readings) {
      r.saved_reading = r.reading;
      r.show_image = !this.hubID || !r.saved_reading || r.saved_reading <= 0;
      if (r.duration && r.kwhdelta) {
        r.kwhperminute = Math.round(600000 * r.kwhdelta / r.duration) / 10000;
        r.kwhdelta  = Math.round(r.kwhdelta);
      }
      updated.push(r);
    }
    this.readings = updated;
  }

  earlier(): void {
    let created: string = null;
    try {
      created = this.readings[this.readings.length - 1].created;
      if (!this.fromTimestamps) {
        this.fromTimestamps = <string[]> [];
      }
      this.fromTimestamps.push(this.readings[0].created);
    } catch (err) {
      console.log(err);
    }
    this.refresh(created);
  }

  later(): void {
    let created: string = null;
    if (this.fromTimestamps) {
      try {
        created = this.fromTimestamps[this.fromTimestamps.length - 1];
        this.fromTimestamps = this.fromTimestamps.slice(0, -1);
      } catch (err) {}
    }
    this.refresh(created);
  }

  refresh(created: string): void {
    this.hubService.getMeterReadings(+this.hubID, created)
      .subscribe(
        values => this.newReadings(values),
        err => MeterReadingsComponent.handleRefreshError(err)
      );
  }

  save(reading: MeterReading): void {
    console.log('Should save ' + reading.reading + ' for UID ' + reading.uid);
    this.hubService.saveMeterReading(reading)
      .subscribe(() => reading.saved_reading = reading.reading);
  }

  showImage(reading: MeterReading): void {
    reading.show_image = true;
  }
  hideImage(reading: MeterReading): void {
    reading.show_image = false;
  }
}

